module.exports = __webpack_public_path__ + "img/tarjeta_code_preview.a699502.png";